<template>
	<div id="home-view">
		<banner :mode="this.mode"></banner>
		<depo-farm :mode="this.mode"></depo-farm>
	</div>
</template>

<script>
import Banner from "@/components/reusables/Banner";
import DepositFarm from "@/components/DepositFarm";

export default {
	name: "Home",
	components: {
		'banner': Banner,
		'depo-farm': DepositFarm
	},
	props: {
		mode: String
	}
};
</script>
